import { Button, Dialog, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import { ApiRequest } from "GlobalFunctions";
import AutocompleteField from "elements/AutocompleteField";

export default function CitiesEditor(props: any) {
  const { setLoading, openEditor, setOpenEditor, city_id, loadList } = props;
  const { enqueueSnackbar } = useSnackbar();

  const defaultValues = {
    id: city_id ? city_id : "null",
    region_id: "",
    dane_code: "",
    name: "",
  };

  const [formValues, setFormValues] = useState(defaultValues);

  useEffect(() => {
    if (city_id) {
      ApiRequest({
        url: "/locationCities/details",
        method: "get",
        headers: { ltkn: localStorage.getItem("ltkn") },
        query: { id: city_id },
        setResponse: (response: any) => {
          setFormValues(response.data);
        },
      });
    } else {
      setFormValues(defaultValues);
    }
  }, [city_id]);

  const handleInputChange = (e: { target: { name: any; value: any } }) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = async () => {
    setLoading(true);
    await ApiRequest({
      url: "/locationCities/addEdit",
      method: "post",
      headers: { ltkn: localStorage.getItem("ltkn") },
      body: formValues,
      setResponse: (response: any) => {
        if (response.status === "success") {
          enqueueSnackbar("Ciudad guardada con éxito", { variant: "success" });
          setOpenEditor(false);
          loadList();
        } else {
          enqueueSnackbar(response.message, { variant: "error" });
        }
        setLoading(false);
      },
    });
  };

  return (
    <Dialog open={openEditor} onClose={() => setOpenEditor(false)}>
      <div className="DialogContainer" style={{ maxWidth: "502px" }}>
        <div className="ModuleWrapper">
          <div className="boxContainerHeader">
            <div className="boxContainerTitle">
              <h2 className="h2_title">Ciudad</h2>
              <span className="h2_subtitle">Editar</span>
            </div>
          </div>

          <div className="input_group">
            <AutocompleteField
              label="Región"
              endpoint="/locationRegions/list"
              value={formValues.region_id}
              onChange={(newValue: any) => {
                setFormValues({
                  ...formValues,
                  region_id: newValue ? newValue.value : "",
                });
              }}
            />

            <TextField
              id="dane_code"
              name="dane_code"
              label="Código DANE"
              type="text"
              required
              fullWidth
              value={formValues.dane_code}
              onChange={handleInputChange}
            />

            <TextField
              id="name"
              name="name"
              label="Nombre de la Ciudad"
              type="text"
              required
              fullWidth
              value={formValues.name}
              onChange={handleInputChange}
            />
          </div>

          <div className="dialogButtons">
            <Button onClick={() => setOpenEditor(false)} variant="outlined">
              Cancelar
            </Button>
            <Button onClick={handleSubmit} variant="contained">
              Guardar
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
